// Доступ взрослого: второй ключ в той же ссылке.
//
// Роутера в приложении нет, и здесь это выгодно: кто вы — решает ключ.
// `?k=<ключ ученика>` открывает приложение ученика, `?k=t-<ключ репетитора>`
// — страницу взрослого (docs/14-tutor.md).
//
// **Ключ взрослого не сохраняется и из адреса не вычищается**, в отличие от
// ученического, и обе половины этого решения записаны. Не сохраняется —
// потому что браузер в доме общий: положи оба ключа в один localStorage, и
// второй затрёт первый, а ссылка взрослого останется в браузере ребёнка после
// того, как взрослый посмотрел с его компьютера. Не вычищается — потому что
// тогда ссылка единственный носитель ключа, и вычищенный адрес терял бы
// страницу на первом же обновлении.
//
// Цена названа честно: адрес взрослого живёт в его закладках и в истории его
// браузера. Это ссылка на страницу, которая в списках эталонов не показывает
// (docs/14-tutor.md) — то есть утечка стоит просмотра чужого прогресса, а не
// решебника.

/**
 * Приставка ключа взрослого. По ней приложение решает, кого открывать, НЕ
 * спрашивая сервер: запрос «а чей это ключ» означал бы круг до Convex перед
 * первым кадром у всех, включая ученика.
 *
 * Подделать её ничего не стоит, и это не защита: сервер всё равно ищет ключ в
 * `tutors` и отказывает. Приставка отвечает на вопрос «какой экран рисовать»,
 * а не на вопрос «можно ли».
 */
export const TUTOR_PREFIX = "t-";

/** Ключ взрослого из ссылки. Пустая строка — открывали не им. */
export function readTutorKey(): string {
  try {
    const fromLink = new URLSearchParams(window.location.search).get("k");
    return fromLink !== null && fromLink.startsWith(TUTOR_PREFIX) ? fromLink : "";
  } catch {
    return "";
  }
}
